<template>
  <div>
    <el-tabs v-model="activeTab" @tab-click="handleClick">
      <el-tab-pane label="Under/Over PMT" name="sales">
        <sales ref="sales" :selectedRow="selectedRow"/>
      </el-tab-pane>
      <el-tab-pane label="Cash Advances Received" name="cashAdvances">
        {{msg}}
      </el-tab-pane>
      <el-tab-pane label="Liquidation Summary" name="liquidationSummary">
        {{msg}}
      </el-tab-pane>
      <el-tab-pane label="GL Subsidiary Account" name="subsidiaryAccount">
        {{msg}}
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
  import Sales from '@/components/clients/aT/aF/Sales.vue'

  export default {
    name: 'AdvancesFrom',
    props: ['selectedRow'],
    components: {
      Sales,
    },
    data() {
      return {
        activeTab: 'sales',
        msg: 'Sorry, this feature now under development will be ready later.',
      }
    },
    methods: {
      openTab() {
        this.activeTab = 'sales'
        this.$refs['sales'].openTab()
      },
      handleClick(tab, event) {
        if (tab.name === 'sales'){
          this.$refs['sales'].openTab()
        }
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>